import {
  OPEN_PAGE_NAME,
  SWITCH_LANG,
  INIT_SELECT_BOX,
  TOGGLE_SELECT_BOX,
  INIT_WORKLIST,
  INIT_WORK_DETAIL_LIST,
  CLEAR_WORK_DETAIL_LIST,
  TOGGLE_MASK,
  TOAST,
  CLOSE_TOAST,
  CLOSE_IMAGE_PREVIEW,
  OPEN_IMAGE_PREVIEW
} from './event-type';
import languages from '../languages';
import axios from 'axios';
import qs from 'qs';
import { setTimeout } from 'timers';
import formatAdapter from '../../utiles/supportTextAdapter';
import {
  appendEntryPageParams,
  post,
  get,
  SUPPORT_REQ_URL,
  PASSPORT_HOST
} from '../ultile';
import globalConfig from '../../utiles/globalConfig';
import { getFingerprint } from '../../utiles/fingerPrint';
const CHECK_LOGIN_ACTION = 'center/ajax/get_user_json';
languages.init();
axios.defaults.withCredentials = true;

let language = languages.getAll();

// 重复翻译的文案，针对性解决
language['creatework_submit'] =
  language['creatework_submit'] || language['submit'];
language['mywork_headerTitle'] =
  language['mywork_headerTitle'] || language['mylist_headerTitle'];
language['mywork_sendMessage'] =
  language['mywork_sendMessage'] || language['send'];
language['mywork_goGame'] =
  language['mywork_goGame'] || language['creatework_goGame'];
language['mywork_uploadTips'] =
  language['mywork_uploadTips'] || language['creatework_uploadTips'];

const getEscapeText = text => {
  let div = document.createElement('div');
  div.innerHTML = text;
  let result = div.innerText;
  div = null;
  return result;
};

const State = {
  state: {
    letters: language, // 所有文案
    workList: [], // 工单列表
    workDetailList: [], // 工单详情，对话列表
    toast: {
      show: false,
      text: ''
    }, // 通用系统通知窗
    langList: languages.getLangText(),
    language: languages.language, // 链接参数带过来的语言
    imagePreview: {
      src: '',
      open: false
    }, // 图片预览插件
    pageComponent: 'mylist'
  },
  getters: {
    getPageComponent: state => state.pageComponent
  },
  mutations: {
    [OPEN_PAGE_NAME](state, payload) {
      state.pageComponent = payload;
    },
    /**
     * 根据语言切换全局文案
     * @param {*} state
     * @param {*} lang
     */
    [SWITCH_LANG](state, lang) {
      let langLimit = ['en', 'zh-CN', 'es'];
      if (!langLimit.indexOf(lang)) {
        lang = 'en';
      }
      state.language = lang;
      languages.setLanguage(lang);
      state.letters = formatAdapter(languages.getAll());
    },
    [INIT_SELECT_BOX](state, payload) {
      if (payload instanceof Array) {
        state.selectBoxList = payload;
      }
    },
    [TOGGLE_SELECT_BOX](state) {
      state.selectBoxShow = !state.selectBoxShow; // selectBox中的内容，可能是同步、也可能是异步数据
      if (state.selectBoxShow) {
        this.commit(INIT_SELECT_BOX);
      }
    },
    [INIT_WORKLIST](state, payload) {
      // 2023.10.16 兼容后端的格式可能会变，如果不是数组就不处理
      if (Object.prototype.toString.call(payload) !== '[object Array]') return;
      let workList = state.workList;
      while (workList.length) {
        workList.shift();
      }
      for (let i = 0; i < payload.length; i++) {
        workList.push(payload[i]);
      }
    },
    [INIT_WORK_DETAIL_LIST](state, payload) {
      let workDetailList = state.workDetailList;
      while (workDetailList.length) {
        workDetailList.shift();
      }
      for (let i = 0; i < payload.length; i++) {
        let obj = {
          ...payload[i],
          MESSAGE: getEscapeText(payload[i].MESSAGE)
        };
        workDetailList.push(obj);
      }
    },
    [CLEAR_WORK_DETAIL_LIST](state) {
      let workDetailList = state.workDetailList;
      while (workDetailList.length) {
        workDetailList.shift();
      }
    },
    [TOGGLE_MASK](state) {
      state.maskShow = !state.maskShow;
    },
    [TOAST](state, payload) {
      state.toast.show = true;
      state.toast.text = payload;
      setTimeout(() => {
        this.commit(CLOSE_TOAST);
      }, 1500);
    },
    [CLOSE_TOAST](state) {
      state.toast.show = false;
      state.toast.text = '';
    },
    [CLOSE_IMAGE_PREVIEW](state) {
      state.imagePreview.open = false;
    },
    [OPEN_IMAGE_PREVIEW](state, payload) {
      state.imagePreview.src = payload;
      state.imagePreview.open = true;
    }
  },
  actions: {
    // 游戏列表
    getGameList({}, payload) {
      return get(`${SUPPORT_REQ_URL}/getGames`, {
        game_id: payload || globalConfig.getHrefParam('gameId') || globalConfig.getHrefParam('game_id') || '',
        user_id_cross: globalConfig.getHrefParam('uid') || '',
        login_account: globalConfig.getHrefParam('loginAccount') || ''
      });
    },

    // 服务器列表
    getServerList({ state }, payload) {
      return get(`${SUPPORT_REQ_URL}/getServersByGameId`, {
        game_id: payload,
        zone: state.language,
        user_id_cross: globalConfig.getHrefParam('uid') || '',
        login_account: globalConfig.getHrefParam('loginAccount') || ''
      });
    },

    // 获取玩家角色名列表
    getCharName({ state }, payload) {
      let { game_id, server_id } = payload;
      return get(`${SUPPORT_REQ_URL}/getCharName`, {
        game_id,
        server_id,
        zone: state.language,
        user_id_cross: globalConfig.getHrefParam('uid') || '',
        login_account: globalConfig.getHrefParam('loginAccount') || ''
      });
    },

    // 越南大掌柜工单页特殊处理
    getCharNameDcqvn({ state }, payload) {
      let { game_id, server_id } = payload;
      return get(`//gsupport.dcqvn.com/index/getCharName`, {
        game_id,
        server_id,
        zone: state.language,
        user_id_cross: globalConfig.getHrefParam('uid') || '',
        login_account: globalConfig.getHrefParam('loginAccount') || ''
      });
    },

    // 获取玩家信息
    getUserInfo({ state }, payload) {
      let { game_id, server_id, role_id } = payload;
      return get(`${SUPPORT_REQ_URL}/getGameData`, {
        game_id,
        server_id,
        role_id,
        zone: state.language,
        user_id_cross: globalConfig.getHrefParam('uid') || '',
        login_account: globalConfig.getHrefParam('loginAccount') || ''
      });
    },
    // 工单列表
    getWorkList({ commit, state }) {
      return new Promise(resolve => {
        get(`${SUPPORT_REQ_URL}/getOrderList`, {
          zone: state.language,
          gpid: globalConfig.getHrefParam('gpid') || '',
          idfa: globalConfig.getHrefParam('idfa') || '',
          e_info: globalConfig.getHrefParam('e_info') || '',
          finger_print: getFingerprint(),
          user_id_cross: globalConfig.getHrefParam('uid') || '',
          login_account: globalConfig.getHrefParam('loginAccount') || '',
          game_id:
            globalConfig.getHrefParam('gameId') ||
            globalConfig.getHrefParam('gameID') ||
            globalConfig.getHrefParam('game_id') ||
            ''
        }).then(({ res }) => {
          if (res.result === 1) {
            commit(INIT_WORKLIST, res.data?.LIST);
          }
          resolve(res);
        });
      });
    },
    // 工单详情
    getWorkDetail({ commit }, workId) {
      return new Promise(resolve => {
        get(`${SUPPORT_REQ_URL}/getMessage`, {
          support_order_id: workId,
          idfa: globalConfig.getHrefParam('idfa') || '',
          gpid: globalConfig.getHrefParam('gpid') || '',
          e_info: globalConfig.getHrefParam('e_info') || '',
          finger_print: getFingerprint(),
          user_id_cross: globalConfig.getHrefParam('uid') || '',
          login_account: globalConfig.getHrefParam('loginAccount') || ''
        }).then(({ res }) => {
          if (res.result === 1) {
            commit(INIT_WORK_DETAIL_LIST, res.data);
          } else {
            commit(TOAST, res.data.msg);
            setTimeout(() => {
              commit(CLOSE_TOAST);
            }, 1500);
          }
        });
      });
    },

    // 提交工单
    createWork({ commit, state }, params) {
      params.zone = state.language;
      params.gpid = globalConfig.getHrefParam('gpid') || '';
      params.idfa = globalConfig.getHrefParam('idfa') || '';
      params.e_info = globalConfig.getHrefParam('e_info') || '';
      params.finger_print = getFingerprint();
      params.package_name = globalConfig.getHrefParam('packageName') || '';
      params['user_id_cross'] = globalConfig.getHrefParam('uid') || '';
      params['login_account'] = globalConfig.getHrefParam('loginAccount') || '';
      params = Object.assign({}, globalConfig.getHrefParamObj(), params);
      return axios
        .post(
          `${SUPPORT_REQ_URL}/create_request`,
          qs.stringify(appendEntryPageParams(params), {
            arrayFormat: 'brackets'
          })
        )
        .then(res => {
          if (res.data.result !== 1) {
            commit(TOAST, res.data.msg);
            setTimeout(() => {
              commit(CLOSE_TOAST);
            }, 1500);
          }
          return res;
        });
    },

    // 上传图片
    uploadImg({ commit, state }, params) {
      params.type = 'support_order';
      params.zone = state.language;
      params.finger_print = getFingerprint();
      params.e_info = globalConfig.getHrefParam('e_info');
      params['user_id_cross'] = globalConfig.getHrefParam('uid') || '';
      params['login_account'] = globalConfig.getHrefParam('loginAccount') || '';
      return new Promise(resolve => {
        post(`${SUPPORT_REQ_URL}/uploadImg`, params).then(({ res }) => {
          if (res.result !== 1) {
            commit(TOAST, res.data.msg);
            setTimeout(() => {
              commit(CLOSE_TOAST);
            }, 1500);
          }
          resolve(res);
        });
      });
    },

    // 给客服发消息
    sendMessage({ commit, state }, params) {
      params.zone = state.language;
      params.gpid = globalConfig.getHrefParam('gpid') || '';
      params.idfa = globalConfig.getHrefParam('idfa') || '';
      params.e_info = globalConfig.getHrefParam('e_info') || '';
      params.finger_print = getFingerprint();
      params['user_id_cross'] = globalConfig.getHrefParam('uid') || '';
      params['login_account'] = globalConfig.getHrefParam('loginAccount') || '';
      return new Promise(resolve => {
        post(`${SUPPORT_REQ_URL}/message_request`, params).then(({ res }) => {
          if (res.result === 1) {
            commit(INIT_WORK_DETAIL_LIST, res.data);
          } else {
            commit(TOAST, res.data.msg);
            setTimeout(() => {
              commit(CLOSE_TOAST);
            }, 1500);
          }
          resolve();
        });
      });
    },
    // 给客服评分
    evaluation({ commit, state }, params) {
      params.zone = state.language;
      params.gpid = globalConfig.getHrefParam('gpid') || '';
      params.idfa = globalConfig.getHrefParam('idfa') || '';
      params.e_info = globalConfig.getHrefParam('e_info') || '';
      params.finger_print = getFingerprint();
      params['user_id_cross'] = globalConfig.getHrefParam('uid') || '';
      params['login_account'] = globalConfig.getHrefParam('loginAccount') || '';
      return new Promise(resolve => {
        post(`${SUPPORT_REQ_URL}/evaluation_request`, params).then(
          ({ res }) => {
            if (res.result !== 1) {
              commit(TOAST, res.data.msg);
              setTimeout(() => {
                commit(CLOSE_TOAST);
              }, 1500);
            }
            resolve(res);
          }
        );
      });
    },
    // 检查登陆态
    checkLogin() {
      return get(`${PASSPORT_HOST}${CHECK_LOGIN_ACTION}`, {
        user_id_cross: globalConfig.getHrefParam('uid') || '',
        login_account: globalConfig.getHrefParam('loginAccount') || ''
      });
    },
    // 越南大掌柜工单页特殊处理，使用该域名
    checkLoginDcqvn() {
      return get(`//gpassport.dcqvn.com/${CHECK_LOGIN_ACTION}`, {
        user_id_cross: globalConfig.getHrefParam('uid') || '',
        login_account: globalConfig.getHrefParam('loginAccount') || ''
      });
    }
  }
};
export default State;
